<template>
  <div
    :class="{
      'hidden md:block': !hideOnMobile,
    }"
  >
    <VisibleByVerizonPopup
      v-if="hasPartner(props.partnerPromoCodes, 'VISIBLE')"
    />

    <NoblePopup v-else-if="hasPartner(props.partnerPromoCodes, 'NOBLE')" />

    <BestPhonePlansPopup
      v-else-if="hasPartner(props.partnerPromoCodes, 'BESTPHONEPLANS')"
    />

    <GoogleFiPopup
      v-else-if="hasPartner(props.partnerPromoCodes, 'GOOGLE_FI')"
    />
  </div>
</template>

<script setup lang="ts">
import type { PartnerPromoCode } from '~/api/partner-promo-code/types'

import BestPhonePlansPopup from './components/BestPhonePlansPopup/BestPhonePlansPopup.vue'
import GoogleFiPopup from './components/GoogleFiPopup/GoogleFiPopup.vue'
import NoblePopup from './components/NoblePopup/NoblePopup.vue'
import VisibleByVerizonPopup from './components/VisibleByVerizonPopup/VisibleByVerizonPopup.vue'
import { hasPartner } from './utils/hasPartner'

const props = defineProps<{
  partnerPromoCodes: PartnerPromoCode[]
  hideOnMobile?: boolean
}>()
</script>
